<template>
    <design-2021-apprentice-data-table
        class="group-progress-category-overview-table"
        key="group-progress-ctegory-overview"
        :items="items"
        :fields="fields"
        :search-term="searchTermIn"
        nosearch
        :custom-per-page="rowsPerPage.selected"
        :show-empty="true">
        <template v-slot:cell(name)="data">
            <div class="student-name">
                <b-button
                    class="btn-open btn-assignment-view"
                    variant="primary-icon-only"
                    :href="viewRoute(data.item)">
                </b-button>
                <span class="name">{{ data.item.name }}</span>
            </div>
        </template>

        <template v-slot:cell(sub_project)="data">
            <div class="sub-project">
                {{ getStudentSubProjectName(data.item) }}
            </div>
        </template>

        <template
            v-for="assignmentOption in subAssignmentsOptions"
            v-slot:[assignmentCell(assignmentOption)]="row">
            <div
                class="progress-click"
                @click="viewAssignment(row.item.id, subAssignmentsOptions.value)">
                <div v-for="assignment in row.item.assignments">
                    <div
                        class="status"
                        v-if="assignment.id === assignmentOption.value">
                        <b-badge
                            class="open-badge"
                            v-if="assignment.status === 'open'"
                            variant="open">
                            Open
                        </b-badge>
                        <b-badge
                            class="open-badge"
                            v-if="assignment.status === 'closed'"
                            variant="closed">
                            {{ $t('group.progress.completed') }}
                        </b-badge>
                        <b-badge
                            class="open-badge"
                            v-if="assignment.status === 'submitted'"
                            variant="submitted">
                            {{ $t('group.progress.completed') }}
                        </b-badge>
                        <b-badge
                            class="open-badge"
                            v-if="assignment.status === 'reopened'"
                            variant="reopened">
                            {{ $t('group.progress.reopened') }}
                        </b-badge>
                    </div>
                </div>
            </div>
        </template>

        <template #cell(last_submitted)="data">
            <div
                class="last_submitted"
                v-if="data.item.last_submitted">
                {{ data.item.last_submitted | date_time_om }}
            </div>
        </template>

        <template #cell(last_updated)="data">
            <div
                class="last_updated"
                v-if="data.item.last_updated">
                {{ data.item.last_updated | date_time_om }}
            </div>
        </template>

        <template #empty="scope">
            <div class="not-found with-header attachments-list">
                <div class="icon">
                    <i class="fas fa-exclamation-circle"></i>
                </div>
                <div class="alert-notice">{{ $t('group.progress.no_students_found') }}</div>
            </div>
        </template>
    </design-2021-apprentice-data-table>
</template>

<script>
export default {
    name: 'design-2021-group-progress-category-overview-all-sub-assignments-component',
    props: {
        groupDataIn: {
            type: Object,
            required: true,
        },
        searchTermIn: {
            type: String,
            required: false,
        },
        selectedStatusIn: {
            type: Array,
            required: true,
        },
        subAssignmentsOptions: {
            type: Array,
            required: true,
        },
        groupIn: {
            type: Object,
            required: true,
        },
        studentPerProjectsIn: {
            type: Array,
            required: true,
        },
        selectedAssignmentsFilter: {
            type: Number,
            required: true,
        },
    },
    inject: ['rowsPerPage'],
    computed: {
        fields() {
            let fields = [
                {
                    key: 'name',
                    label: this.$t('common.first_name'),
                    sortable: true,
                },
                {
                    key: 'surname',
                    label: this.$t('common.last_name'),
                    sortable: true,
                },
            ];

            if (this.groupIn.children.length > 0) {
                fields.push({
                    key: 'sub_project',
                    label: this.$t('group.progress.classes'),
                    sortable: true,
                });
            }

            for (const subAssignment of this.subAssignmentsOptions) {
                if (subAssignment.value === null) {
                    continue;
                }

                fields.push({
                    key: `sub-assignment-${subAssignment.value}`,
                    label: subAssignment.text,
                });
            }

            fields.push({
                key: 'last_submitted',
                label: this.$t('group.progress.recently_submitted'),
                sortable: true,
            });

            fields.push({
                key: 'last_updated',
                label: this.$t('group.progress.last_modified'),
                sortable: true,
            });

            return fields;
        },

        items() {
            let projectIdArray = this.studentPerProjectsIn.map((project) => project.project_id);
            let assignmentsData = this.groupDataIn.sub_assignments.map((subAssignment) => {
                let statuses = {
                    name: subAssignment.user.name,
                    surname: subAssignment.user.surname,
                    user_id: subAssignment.user.id,
                    id: subAssignment.project_id,
                    assignments: [],
                };

                for (const assignment of subAssignment.assignments) {
                    if (assignment.assignment_id === this.selectedAssignmentsFilter) {
                        statuses.last_updated = assignment.last_updated;
                        statuses.last_submitted = assignment.last_submitted;

                        let new_assignment = assignment.sub_assignments.map((child_assisgnment) => {
                            return {
                                id: child_assisgnment.id,
                                name: child_assisgnment.name,
                                deadline: child_assisgnment.deadline,
                                status: child_assisgnment.status,
                            };
                        });

                        statuses.assignments.push(...new_assignment);
                    }
                }

                return statuses;
            });

            const submitted = this.selectedStatusIn.includes('submitted');
            const reopened = this.selectedStatusIn.includes('reopened');
            const closed = this.selectedStatusIn.includes('closed');
            const open = this.selectedStatusIn.includes('open');

            assignmentsData = assignmentsData
                .map((data) => {
                    data.assignments = data.assignments.filter((chore) => {
                        let include = false;

                        if (submitted && chore.status === 'submitted') {
                            include = true;
                        }

                        if (reopened && chore.status === 'reopened') {
                            include = true;
                        }

                        if (closed && chore.status === 'closed') {
                            include = true;
                        }

                        if (open && chore.status === 'open') {
                            include = true;
                        }

                        if (include) {
                            return chore;
                        }
                    });
                    return data;
                })
                .filter((task) => task.assignments.length > 0);

            return assignmentsData.filter((data) => projectIdArray.includes(data.id));
        },
    },

    methods: {
        viewRoute(project) {
            return this.routes.projectShow(project.id);
        },

        getStudentSubProjectName(data) {
            for (const student of this.studentPerProjectsIn) {
                if (student.project_id === data.id && student.id === data.user_id) {
                    return student.groups.join(', ');
                }
            }
        },

        viewAssignment(project_id, assignment_id) {
            window.location.href = this.routes.baseUrl() + this.routes.assignmentShow(assignment_id, project_id);
        },

        getToolTipLabel(number, label) {
            switch (label) {
                case 'closed':
                    return `${number} ${this.$t('group.progress.completed')}`;

                case 'submitted':
                    return `${number} ${this.$t('group.progress.submitted')}`;

                case 'reopened':
                    return `${number} ${this.$t('group.progress.reopened')}`;

                case 'open':
                    return `${number} ${this.$t('common.open')}`;
            }
        },

        assignmentCell(option) {
            if (option.value !== null) {
                return `cell(sub-assignment-${option.value})`;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.student-name {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
}

::v-deep .badge {
    padding: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'eight');
    font-weight: $font-weight-medium;
    font-size: 0.75rem;
}
</style>
